// Módulo: Gestão de Certificados Digitais
// Responsável pelo upload e listagem de certificados A1

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.financeiro = window.FazendaRP.Pages.financeiro || {};

window.FazendaRP.Pages.financeiro.certificados = window.FazendaRP.Pages.financeiro.certificados || {};

Object.assign(window.FazendaRP.Pages.financeiro.certificados, {

    openModal: function () {
        // Create Overlay
        const modalId = 'modal-certificados-config';
        if (document.getElementById(modalId)) return; // Already open

        const modal = document.createElement('div');
        modal.id = modalId;
        modal.className = 'modal-overlay';
        modal.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:9999;";

        const content = document.createElement('div');
        content.style.background = 'white';
        content.style.padding = '0'; // Padding handled inside
        content.style.borderRadius = '8px';
        content.style.width = '90%';
        content.style.maxWidth = '800px';
        content.style.maxHeight = '90vh';
        content.style.overflowY = 'auto';
        content.style.position = 'relative';

        // Close Button
        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '<i class="fas fa-times"></i>';
        closeBtn.style.cssText = "position:absolute;top:15px;right:15px;background:none;border:none;font-size:1.2rem;cursor:pointer;color:#6b7280;";
        closeBtn.onclick = () => modal.remove();
        content.appendChild(closeBtn);

        modal.appendChild(content);
        document.body.appendChild(modal);

        // Render Content
        this.renderCertificados(content);

        // Close on click outside
        modal.onclick = (e) => {
            if (e.target === modal) modal.remove();
        };
    },

    renderCertificados: async function (container) {
        container.innerHTML = `
            <div class="certificados-container" style="padding: 20px; max-width: 800px; margin: 0 auto;">
                <h3 style="color: #065f46; border-bottom: 2px solid #e5e7eb; padding-bottom: 10px; margin-bottom: 20px;">
                    <i class="fas fa-certificate"></i> Certificados Digitais (A1)
                </h3>

                <div class="info-box" style="background: #f0fdf4; border: 1px solid #bbf7d0; padding: 15px; border-radius: 8px; margin-bottom: 20px;">
                    <p style="margin: 0; color: #166534; font-size: 0.95rem;">
                        <i class="fas fa-info-circle"></i> 
                        O certificado digital A1 é necessário para que o sistema consulte automaticamente as notas fiscais emitidas contra seu CPF/CNPJ na Receita Federal.
                        O arquivo (.pfx ou .p12) é armazenado de forma segura.
                    </p>
                </div>

                <!-- Form Upload -->
                <div class="upload-area" style="background: white; padding: 25px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 30px;">
                    <h4 style="margin-top: 0; color: #374151;">Novo Certificado</h4>
                    
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                        <div class="form-group">
                            <label style="display: block; font-weight: 500; color: #374151; margin-bottom: 5px;">Arquivo (.pfx ou .p12)</label>
                            <input type="file" id="cert-file" accept=".pfx,.p12" style="width: 100%; border: 1px solid #d1d5db; padding: 8px; border-radius: 6px;">
                        </div>

                        <div class="form-group">
                            <label style="display: block; font-weight: 500; color: #374151; margin-bottom: 5px;">Senha do Certificado</label>
                            <div style="position: relative;">
                                <input type="password" id="cert-password" placeholder="Digite a senha..." style="width: 100%; border: 1px solid #d1d5db; padding: 8px; border-radius: 6px;">
                                <button type="button" id="toggle-pass" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); border: none; background: none; color: #6b7280; cursor: pointer;">
                                    <i class="fas fa-eye"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top: 15px; text-align: right;">
                        <button id="btn-save-cert" class="btn btn-primary" style="background-color: #059669; color: white; padding: 10px 20px; border: none; border-radius: 6px; cursor: pointer; display: inline-flex; align-items: center; gap: 8px;">
                            <i class="fas fa-upload"></i> Upload Seguro
                        </button>
                    </div>
                </div>

                <!-- Lista -->
                <h4 style="color: #374151;">Certificados Ativos</h4>
                <div id="lista-certificados">
                    <div style="text-align: center; padding: 20px; color: #6b7280;">Carregando...</div>
                </div>
            </div>
        `;

        // Toggle Password
        const toggleBtn = container.querySelector('#toggle-pass');
        const passInput = container.querySelector('#cert-password');
        toggleBtn.onclick = () => {
            if (passInput.type === 'password') {
                passInput.type = 'text';
                toggleBtn.innerHTML = '<i class="fas fa-eye-slash"></i>';
            } else {
                passInput.type = 'password';
                toggleBtn.innerHTML = '<i class="fas fa-eye"></i>';
            }
        };

        // Save Action
        container.querySelector('#btn-save-cert').onclick = async () => {
            const fileInput = container.querySelector('#cert-file');
            const password = passInput.value;

            if (!fileInput.files[0]) {
                window.FazendaRP.Toast.show('warning', 'Atenção', 'Selecione o arquivo do certificado.');
                return;
            }
            if (!password) {
                window.FazendaRP.Toast.show('warning', 'Atenção', 'Digite a senha do certificado.');
                return;
            }

            const file = fileInput.files[0];
            const btn = container.querySelector('#btn-save-cert');

            // Helper to clean filename
            const cleanName = file.name.replace(/[^a-zA-Z0-9._-]/g, '');

            try {
                btn.disabled = true;
                btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Enviando...';

                // 1. Upload File to Storage
                const filePath = `certs/${Date.now()}_${cleanName}`;
                // Using 'comprovantes' bucket for now as it exists, ideally 'secure-certs'
                // NOTE: In production, ensure this bucket is PRIVATE
                const { data: uploadData, error: uploadError } = await window.FazendaRP.supabase
                    .storage
                    .from('comprovantes')
                    .upload(filePath, file);

                if (uploadError) throw uploadError;

                console.log("Certificado Uploaded:", uploadData);

                // 2. Save Metadata & Credentials in DB
                // storing password in DB is risky, ideally use Vault or Env Vars, 
                // but for this MVP asking user to re-type every time is bad UX for automation.
                // We will store it for the Bot to pick up.
                const { error: dbError } = await window.FazendaRP.supabase
                    .from('config_certificados')
                    .insert([{
                        nome_arquivo: cleanName,
                        caminho_storage: filePath,
                        senha: password, // TODO: Encrypt this client-side or server-side if possible?
                        ativo: true,
                        data_upload: new Date().toISOString()
                    }]);

                if (dbError) {
                    // Try to rollback file
                    await window.FazendaRP.supabase.storage.from('comprovantes').remove([filePath]);
                    throw dbError;
                }

                window.FazendaRP.Toast.show('success', 'Sucesso', 'Certificado configurado!');

                // Update Parent UI if present
                if (window.FazendaRP.Pages.financeiro.inbox && window.FazendaRP.Pages.financeiro.inbox.checkCertificateStatus) {
                    window.FazendaRP.Pages.financeiro.inbox.checkCertificateStatus();
                }

                fileInput.value = '';
                passInput.value = '';
                this.loadCertList(container);

            } catch (err) {
                console.error(err);
                if (err.message && err.message.includes('relation "config_certificados" does not exist')) {
                    window.FazendaRP.Toast.show('error', 'Erro de Tabela', 'A tabela de configuração não existe no banco. Contate o suporte.');
                } else {
                    window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao salvar certificado: ' + err.message);
                }
            } finally {
                btn.disabled = false;
                btn.innerHTML = '<i class="fas fa-upload"></i> Upload Seguro';
            }
        };

        this.loadCertList(container);
    },

    loadCertList: async function (container) {
        const listDiv = container.querySelector('#lista-certificados');

        try {
            const { data, error } = await window.FazendaRP.supabase
                .from('config_certificados')
                .select('*')
                .eq('ativo', true)
                .order('data_upload', { ascending: false });

            if (error) {
                // If table doesn't exist yet, handle gracefully for dev
                if (error.code === '42P01') {
                    listDiv.innerHTML = '<div style="color:red; background:#fee2e2; padding:10px; border-radius:4px;">Tabela "config_certificados" não criada. Execute o SQL de migração.</div>';
                    return;
                }
                throw error;
            }

            if (!data || data.length === 0) {
                listDiv.innerHTML = '<div style="background: #f9fafb; padding: 20px; text-align: center; border-radius: 8px; color: #6b7280;">Nenhum certificado ativo.</div>';
                return;
            }

            listDiv.innerHTML = data.map(cert => `
                <div style="background: white; border: 1px solid #e5e7eb; border-left: 4px solid #059669; padding: 15px; border-radius: 4px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                    <div>
                        <div style="font-weight: 600; color: #374151;">${cert.nome_arquivo}</div>
                        <div style="font-size: 0.85rem; color: #6b7280;">Enviado em: ${new Date(cert.data_upload).toLocaleString('pt-BR')}</div>
                    </div>
                    <button class="btn-delete-cert" data-id="${cert.id}" style="color: #dc2626; background: #fee2e2; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; font-size: 0.9rem;">
                        <i class="fas fa-trash"></i> Remover
                    </button>
                </div>
            `).join('');

            // Delete Handlers
            listDiv.querySelectorAll('.btn-delete-cert').forEach(btn => {
                btn.onclick = async () => {
                    if (confirm('Deseja realmente remover este certificado? A automação irá parar.')) {
                        const id = btn.dataset.id;
                        const { error } = await window.FazendaRP.supabase
                            .from('config_certificados')
                            .update({ ativo: false })
                            .eq('id', id);

                        if (!error) this.loadCertList(container);
                    }
                };
            });

        } catch (err) {
            console.error(err);
            listDiv.innerHTML = `<div style="color:red">Erro ao carregar lista: ${err.message}</div>`;
        }
    }
});
